var React = require('react');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step6;
var { $simpleSelect, $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');

class BillingInformation extends React.Component {
    constructor(props) {
        super(props);

        this.clearBillingAddress = this.clearBillingAddress.bind(this);
        this.getAddressFieldsMarkup = this.getAddressFieldsMarkup.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleUseBillingAddressChange = this.handleUseBillingAddressChange.bind(this);
        this.useBillingAddress = this.useBillingAddress.bind(this);
    }

    componentDidMount() {
        this.props.loadApiData('countriesAndStates');

        if (!this.props.appState.isInternational) {
            this.props.updateStepState('country', 'USA');
        }
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    useBillingAddress() {
        var billingAddress = this.props.getStepState(3);
        this.props.updateStepState('addressId', billingAddress.addressId);
        this.props.updateStepState('country', billingAddress.country);
        this.props.updateStepState('addressLine1', billingAddress.addressLine1);
        this.props.updateStepState('addressLine2', billingAddress.addressLine2);
        this.props.updateStepState('addressLine3', billingAddress.addressLine3);
        this.props.updateStepState('city', billingAddress.city);
        this.props.updateStepState('state', billingAddress.state);
        this.props.updateStepState('zip', billingAddress.zip); // zip not currently in step 3
        this.props.updateStepState('phoneNumber', billingAddress.phoneNumber);
    }

    clearBillingAddress() {
        this.props.updateStepState('addressId', 0);
        this.props.updateStepState('country', '');
        this.props.updateStepState('addressLine1', '');
        this.props.updateStepState('addressLine2', '');
        this.props.updateStepState('addressLine3', '');
        this.props.updateStepState('city', '');
        this.props.updateStepState('state', '');
        this.props.updateStepState('zip', '');
        this.props.updateStepState('phoneNumber', '');
    }

    handleUseBillingAddressChange(event) {
        this.props.updateStepState(event.target.name, event.target.checked);

        if (event.target.checked) {
            this.useBillingAddress();
        } else {
            this.clearBillingAddress();
        }
    }

    getAddressFieldsMarkup() {
        const countryMarkup = <$simpleSelect
            value={this.props.stepState.country}
            name="country"
            selectdatafunction={selectableDataFunctions.getApiCountriesFromAllCountries}
            onChange={this.handleInputChange}
            validations={[validationFunctions.required]} />;

        const stateMarkup = ['USA', 'CAN'].includes(this.props.stepState.country)
            ? [<$simpleSelect key={'state-field-required'}
                name="state"
                value={this.props.stepState.state}
                country={this.props.stepState.country}
                selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                onChange={this.handleInputChange}
                validations={[validationFunctions.required]} />, null]
            : [null, <$input type="text" key={'state-field-not-required'}
                name="state"
                value={this.props.stepState.state}
                country={this.props.stepState.country}
                onChange={this.handleInputChange}
                validations={[]} />] ;

        const zipMarkup = ['USA', 'CAN'].includes(this.props.stepState.country)
            ? [<$input key={'zip-field-required'}
                name="zip"
                value={this.props.stepState.zip}
                country={this.props.stepState.country}
                onChange={this.handleInputChange}
                validations={[validationFunctions.required]} />, null] :
            [null, <$input key={'zip-field-not-required'}
                name="zip"
                value={this.props.stepState.zip}
                country={this.props.stepState.country}
                onChange={this.handleInputChange}
                validations={[]} />];

        const addressTypeMarkup = this.props.stepState.useStep3ForBillingAddress
            ? null
            : <div className={"field-wrap"}>
                <label>{labels.step6.addressType}</label>
                <$simpleSelect
                    value={this.props.stepState.addressType}
                    name="addressType"
                    onChange={this.handleInputChange}
                    selectdatafunction={this.props.stepState.step3AddressType ? selectableDataFunctions.getBillingAddressTypeOptions : ''}
                    step3addresstype={this.props.stepState.step3AddressType}
                    validations={[validationFunctions.required]} />
            </div>;

        if (memberTypeChecker.internationalAddressFields(this.props.appState.appType)) {
            return <div className={this.props.stepState.useStep3ForBillingAddress ? 'billing-address-readonly' : ''}>
                <h4>{labels.step6.address}</h4>
                {addressTypeMarkup}
                <div className={"field-wrap"}>
                    <label>{labels.step6.internationalAddress}</label>
                    <$input name="addressLine1" value={this.props.stepState.addressLine1} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <$input name="addressLine2" value={this.props.stepState.addressLine2} onChange={this.handleInputChange} />
                </div>
                <div className={"field-wrap"}>
                    <$input name="addressLine3" value={this.props.stepState.addressLine3} onChange={this.handleInputChange} />
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.country}</label>
                    {countryMarkup}
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.state}</label>
                    {stateMarkup}
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.city}</label>
                    <$input name="city" value={this.props.stepState.city} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.postalCode}</label>
                    {zipMarkup}
                </div>
            </div>;
        } else {
            return <div className={this.props.stepState.useStep3ForBillingAddress ? 'billing-address-readonly' : ''}>
                <h4>{labels.step6.address}</h4>
                {addressTypeMarkup}
                <div className={"field-wrap"}>
                    <label>{labels.step6.address}</label>
                    <$input name="addressLine1" value={this.props.stepState.addressLine1} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <$input name="addressLine2" value={this.props.stepState.addressLine2} onChange={this.handleInputChange} />
                </div>
                <div className={"field-wrap"}>
                    <$input name="addressLine3" value={this.props.stepState.addressLine3} onChange={this.handleInputChange} />
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.country}</label>
                    {countryMarkup}
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.state}</label>
                    {stateMarkup}
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.city}</label>
                    <$input name="city" value={this.props.stepState.city} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                </div>
                <div className={"field-wrap"}>
                    <label>{labels.step6.zip}</label>
                    {zipMarkup}
                </div>
            </div>;
        }
    }

    render() {
        return <div className={"billing-information-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step6.billingInformation}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <div>
                                <input type="checkbox"
                                    id="usecontactinfo"
                                    name="useStep3ForBillingAddress"
                                    checked={this.props.stepState.useStep3ForBillingAddress}
                                    onChange={this.handleUseBillingAddressChange}
                                />
                                <label className={"memberjoin"} htmlFor={"usecontactinfo"}>{labels.step6.useMyContactInfo}</label>
                                {this.getAddressFieldsMarkup()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>;
    }
}

module.exports = BillingInformation;